import {NgModule} from '@angular/core';
import {CbjRippleDirective} from './cbj-ripple.directive';
import {CommonModule} from '@angular/common';
export class CbjRippleModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
  ],
  declarations: [
    CbjRippleDirective
  ],
  exports: [
    CbjRippleDirective
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CbjRippleModule_tsickle_Closure_declarations() {
/** @type {?} */
CbjRippleModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjRippleModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
